import { getVerifiedRole } from '@/utils/verifiedProfile';
import { getUserRole, isClientFacingRole } from '@/utils/auth';
import { canAccessMandatModule } from '@/utils/postLoginRedirect';
import { isItOnlyStaff } from '@/utils/permissions';

export const ROLES = {
  ADMIN: 'admin',
  EMPLOYE: 'employe',
  USER: 'user',
};

/** Rôles staff autorisés sur les espaces back-office (patrimoine + mandat). */
export const STAFF_ROLES = [
  ROLES.ADMIN,
  ROLES.EMPLOYE,
  'saisie',
  'validation',
];

/**
 * Redirection à la racine `/analyse-patrimoniale` : clients et staff → Tableau de bord.
 */
export function redirectAnalysePatrimonialeRoot() {
  if (isItOnlyStaff()) return { path: '/analyse-patrimoniale/diagnostic-it' };
  return { path: '/analyse-patrimoniale/dashboards' };
}

/** Racine `/actions-mandat` : client privé → ses reco, staff → tableau de bord. */
export function redirectActionsMandatRoot() {
  const role = getVerifiedRole() || getUserRole();
  if (isClientFacingRole(role)) {
    if (!canAccessMandatModule(role)) {
      return { path: '/analyse-patrimoniale/dashboards' };
    }
    return { path: '/actions-mandat/mes-recommandations' };
  }
  return { path: '/actions-mandat/dashboards' };
}
